<template>
  <div class="center-div mb-2">
    <a-row class="justify-center">
      <a-col :span="7">
        <div class="mt-4" style="text-align:center">
          <h4
            class="text-bold"
          >{{currentPage === 0 ? 'Register an Account' : 'Hey ' + user.first_name + ', We are almost there'}}</h4>
          <span class="text-opacity">Leverage the power of convenience</span>
        </div>
        <div class="mt-2">
          <a-steps :current="currentPage" size="small">
            <a-step title="Basic Information"/>
            <a-step title="Location Information"/>
          </a-steps>
        </div>
        <div v-show="errorMessages.length > 0 ">
          <error-alert v-for="(msg,index) in errorMessages" :key="index" :message="msg"></error-alert>
        </div>
        <div v-show="successMessage !== ''">
          <success-alert :messages="'successMessage'">
            <span slot="message">
              {{successMessage}} - You can now login to your account by clicking
              <router-link :to="{name: 'login'}">Here</router-link>
            </span>
          </success-alert>
        </div>
        <a-card class="mt-4">
          <a-form v-show="currentPage === 0" @submit="registerUser" :form="form">
            <div>
              <a-form-item class="form-input">
                <h4 class="text-opacity">Your First Name</h4>
                <a-input
                  v-decorator="['first_name', { rules: [{ required: true, message: 'Please input your First name' }] }]"
                  class="custom-input"
                  placeholder="Please Enter your First Name"
                />
              </a-form-item>
              <a-form-item class="form-input">
                <h4 class="text-opacity">Your Last Name</h4>
                <a-input
                  v-decorator="['last_name', { rules: [{ required: true, message: 'Please input your Last name' }] }]"
                  class="custom-input"
                  placeholder="Please Enter your Last Name"
                />
              </a-form-item>
              <a-form-item class="form-input">
                <h4 class="text-opacity">Your Email Address</h4>
                <a-input
                  v-decorator="['email', { rules: [{ required: true, message: 'Please input your Email Address' }] }]"
                  class="custom-input"
                  type="email"
                  placeholder="Please Enter your Email Address"
                />
              </a-form-item>
              <a-form-item class="form-input">
                <h4 class="text-opacity">Your Telephone Number</h4>
                <a-input
                  v-decorator="[
                  'phone',
                  {
                    rules: [{ required: true, message: 'Please input your phone number!' }],
                  },
                ]"
                  class="custom-input"
                  placeholder="Please Enter your Phone Number"
                  style="width: 100%"
                >
                  <!-- <a-select
                    slot="addonBefore"
                    v-decorator="['prefix', { initialValue: '234' }]"
                    style="width: 70px"
                  >
                    <a-select-option value="234" selected>+234</a-select-option>
                    <a-select-option value="235">+874</a-select-option>
                  </a-select>-->
                </a-input>
              </a-form-item>
              <a-form-item class="form-input">
                <h4 class="text-opacity">Your Password</h4>
                <a-input
                  v-decorator="['password', { rules: [{ required: true, message: 'Please input your Password' } ,            {
                validator: validateToNextPassword,
              }] }]"
                  class="custom-input"
                  :type="display"
                  placeholder="Please Enter your Password"
                />
                <span class="show-toggle">
                  <a-icon @click="toggleShow" type="eye" v-show="show"/>
                  <a-icon @click="toggleShow" type="eye-invisible" v-show="hide"/>
                </span>
              </a-form-item>
              <a-form-item class="form-input">
                <h4 class="text-opacity">Confirm Your Password</h4>
                <a-input
                  v-decorator="['confirm', { rules: [{ required: true, message: 'Please Password Should Match' },             {
                validator: compareToFirstPassword,
              }] }]"
                  class="custom-input"
                  :type="display"
                  placeholder="Please Re-enter your Password"
                />
                <span class="show-toggle">
                  <a-icon @click="toggleShow" type="eye" v-show="show"/>
                  <a-icon @click="toggleShow" type="eye-invisible" v-show="hide"/>
                </span>
              </a-form-item>
            </div>
            <a-form-item>
              <button html-type="submit" type="submit" class="btn btn-primary">Register</button>
              <!-- +<a-button type="primary" class="btn btn-primaary" html-type="submit">Register</a-button> -->
            </a-form-item>
            <span>
              Already a user?
              <router-link :to="{name: 'login'}">
                <b class="text-purple">Sign in</b>
              </router-link>to your Account
            </span>
          </a-form>
          <a-form v-show="currentPage === 1" @submit="registerLocation" :form="form2">
            <ul
              class="back-link"
              style="list-style-type: none; display: inline-flex;padding-left: 0; opacity: .7;"
            >
              <li style="padding-right:10px">
                <i style="font-size:20px" class="zmdi zmdi-chevron-left"></i>
              </li>
              <li style="font-size:12px; padding-top:1px" @click="goBack">Go Back</li>
            </ul>
            <a-form-item class="form-input">
              <h4 class="text-opacity">Country of Residence</h4>
              <a-select
                showSearch
                class="custom-input"
                @change="setCountry"
                v-decorator="[
                'country',
                { rules: [{ required: true, message: 'Please select your country!' }] },
              ]"
                placeholder="Please select a country"
              >
                <a-select-option
                  v-for="(country,index) in countries"
                  :key="index"
                  :value="country.name"
                >{{country.name}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item class="form-input">
              <h4 class="text-opacity">State of Residence</h4>
              <a-select
                showSearch
                class="custom-input"
                @change="setState"
                v-decorator="[
                'state',
                { rules: [{ required: true, message: 'Please select your state!' }] },
              ]"
                placeholder="Please select a state"
              >
                <a-select-option
                  v-for="(state,index) in states"
                  :key="index"
                  :value="state.name"
                >{{state.name}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item class="form-input">
              <h4 class="text-opacity">
                City of Residence
                <sup>optional</sup>
              </h4>
              <a-select
                showSearch
                class="custom-input"
                v-decorator="[
                'city',
              ]"
                placeholder="Please select a city"
              >
                <a-select-option
                  v-for="(city,index) in cities"
                  :key="index"
                  :value="city.name"
                >{{city.name}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item class="form-input">
              <h4 class="text-opacity">Zip Code</h4>
              <a-input
                v-decorator="[
                  'zip_code',{
                    rules: [{ required: true, message: 'Please input your zip Code!' }],
                  },
                ]"
                class="custom-input"
                placeholder="Please Enter your Country Zip Code "
                style="width: 100%"
              ></a-input>
            </a-form-item>
            <a-form-item>
              <h4 class="text-opacity">
                Address
                <sup>Optional</sup>

                <a-textarea
                  placeholder="Please enter your current address"
                  :autosize="{ minRows: 2, maxRows: 12 }"
                  v-decorator="[
                  'address'
                ]"
                />
              </h4>
            </a-form-item>
            <a-form-item class="mt-2">
              <button html-type="submit" type="submit" class="btn btn-primary">Finish Registration</button>
              <!-- +<a-button type="primary" class="btn btn-primaary" html-type="submit">Register</a-button> -->
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<style lang="scss" scoped>
.btn-primary {
  width: 100%;
  height: 40px;
  padding-top: 0px !important;
}
ul {
  cursor: pointer;
  &.back-link {
    &:hover {
      opacity: 1 !important;
    }
  }
}
</style>

<script>
import "@/assets/css/auth.scss";
import ErrorAlert from "@/components/Alerts/Error";
import SuccessAlert from "@/components/Alerts/Success";
export default {
  components: { ErrorAlert, SuccessAlert },
  data() {
    return {
      hide: false,
      show: true,
      currentPage: 0,
      display: "password",
      form: this.$form.createForm(this, { name: "coordinated" }),
      form2: this.$form.createForm(this, { name: "coordinated" }),
      user: {
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        phone: "",
        password: "",
        country_id: "",
        state_id: "",
        city_id: "",
        zip_postal_code: "",
        address: ""
      },
      api: this.$baseApi.replace("api/", ""),
      errorMessages: [],
      successMessage: ""
    };
  },
  computed: {
    countries() {
      return this.$store.getters.countries;
    },
    states() {
      return this.user.country_id !== ""
        ? this.$store.getters.states.filter(
            s => s.country_id === this.user.country_id
          )
        : "";
    },
    cities() {
      return this.user.state_id !== ""
        ? this.$store.getters.cities.filter(
            s => s.state_id === this.user.state_id
          )
        : "";
    }
  },
  mounted() {
    this.$store.dispatch("getCountries");
    this.$store.dispatch("getStates");
    this.$store.dispatch("getCities");
  },
  methods: {
    goBack() {
      this.currentPage = 0;
    },
    setCountry(value) {
      this.user.country_id = this.countries.find(s => s.name === value).id;
    },
    setState(value) {
      this.user.state_id = this.states.find(s => s.name === value).id;
    },
    registerUser(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.user.first_name = values.first_name;
          this.user.last_name = values.last_name;
          this.user.email = values.email;
          this.user.username = values.email;
          this.user.phone_number = values.phone;
          this.user.password = values.password;
          this.user["password_confirmation"] = values.password;
          this.currentPage = 1;
        }
      });
    },
    registerLocation(e) {
      e.preventDefault();
      this.errorMessages = [];
      this.form2.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const hide = this.$message.loading(
            "Registering your information, Please hold on a minute"
          );
          this.user.country_id = this.countries.find(s => {
            return s.name === values.country;
          }).id;
          this.user.state_id = this.states.find(s => {
            return s.name === values.state;
          }).id;
          this.user.city_id = this.cities.find(s => {
            return s.name === values.city;
          }).id;
          this.user.zip_postal_code = values.zip_code;
          this.user.street_address = values.address;
          this.user["country"] = this.user.country_id;
          this.user["state"] = this.user.state_id;
          this.user["city"] = this.user.city_id;

          let url = this.api + "/register";
          let data = this.user;
          this.$http
            .post(url, data)
            .then(s => {
              setTimeout(hide, 20);
              this.successMessage = s.data.message;
            })
            .catch(err => {
              setTimeout(hide, 20);
              if (err.response.status === 422) {
                this.errorMessages = Object.values(err.response.data);
              }
            });
        }
      });
    },
    toggleShow() {
      if (this.hide === false) {
        this.hide = true;
        this.display = "password";
      } else {
        this.hide = false;
        this.display = "text";
      }
      if (this.show == true) {
        this.show = false;
        this.display = "text";
      } else {
        this.show = true;
        this.display = "password";
      }
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("Two passwords that you enter is inconsistent!");
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    }
  }
};
</script>

